export default "__VITE_ASSET__Dr7Kkf2E__"